import React, { ReactElement, useEffect } from 'react';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import { DataCollectionValues, useDataCollection } from '../../../../hooks';
import FormRadio from '../../../components/Form/FormRadio';
import StepHeader from '../../../components/Layout/StepHeader';
import { bathroomCountOptions, otherBathroomCountOptions } from '../../../../data/enumerations';
import { Form } from 'formik';

const StepBathroomCount = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    useEffect(() => {
        if (values.bathroomCount && values.bathroomCount !== 'other') {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    const otherOptionSelected =
        values.bathroomCount !== 'other' &&
        otherBathroomCountOptions.some((option) => option.value === values.bathroomCount);

    return (
        <Form>
            <div className="otz-main otz-main--number-bathrooms">
                <StepHeader title="Kolik máte koupelen?" />
                <div className={'otz-main__grid'}>
                    {bathroomCountOptions.map((option) => {
                        return (
                            <div key={option.value}>
                                <FormRadio
                                    name="bathroomCount"
                                    value={option.value}
                                    id={option.value}
                                    label={option.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={'wiz-form-radio--fullwidth m-b-0'}
                                    checked={option.value === values.bathroomCount}
                                />
                            </div>
                        );
                    })}
                    <div className={`otz-main__select wiz-form-container m-b-0 ${otherOptionSelected ? 'wiz-form-container--selected' : ''}`}>
                        <select
                            aria-label="bathroomCount"
                            className="wiz-form-control"
                            name="bathroomCount"
                            id="bathroomCount"
                            onChange={handleChange}
                            value={values.bathroomCount}
                        >
                            {otherBathroomCountOptions.map((option) => {
                                return (
                                    <option key={option.value} value={option.value}>
                                        {option.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepBathroomCount;
